// Module
var code = `  <div class="filters" ng-if="\$ctrl.filter">

    <form name="\$ctrl.filterForm">

      <!-- Branch -->
      <div class="labelled-field labelled-field--long">
        <label for="filter-branch" class="add-on">Branch</label>
        <select
          id="filter-branch"
          class="form-control"
          ng-disabled="\$ctrl.availableBranches && \$ctrl.availableBranches.length === 1"
          ng-model="\$ctrl.filter.branchId"
          ng-change="\$ctrl.onBranchFilterChange()"
          ng-options="branch.id as branch.name for branch in \$ctrl.availableBranches">
          <option value="" ng-if="\$ctrl.availableBranches && \$ctrl.availableBranches.length > 1">(All branches)</option>
        </select>
      </div>

      <!-- Loan product -->
      <div class="labelled-field labelled-field--long">
        <label for="filter-product" class="add-on">Product</label>
        <multiselect id="filter-product"
                     items="\$ctrl.availableLoanTypes"
                     ng-model="\$ctrl.filter.loanTypeIds"
                     label-property="'productName'"
                     value-property="'id'"
                     select-all-option="true"
                     ng-required="true">
        </multiselect>
      </div>

      <!-- PDC status -->
      <div class="labelled-field labelled-field--long" >
        <label for="filter-status" class="add-on">Status</label>
        <multiselect-null-wrapper
          id="filter-status"
          class="form-control"
          ng-model="\$ctrl.filter.status"
          items="\$ctrl.checkStatuses"
          ng-required="true">
        </multiselect-null-wrapper>
      </div>

      <!-- Check registration date -->
      <date-range-picker model="\$ctrl.filter.dateRange"></date-range-picker>
    </form>

    <!-- Actions -->
    <button type="submit"
            ng-click="\$ctrl.doFilter()"
            ng-disabled="\$ctrl.filterForm.\$invalid"
            class="btn btn-primary btn--filter">
      Filter
    </button>

  </div>
  <div class="tab-content">
    <div class="tab-pane" id="tab-loan-pdc-checks" ng-class="{'active': true}">
      <div ng-if="\$ctrl.isDataPresent()">
        <table class="table" ng-table="\$ctrl.tableConfig">
          <tbody class="appraisal-details">
          <tr ng-repeat-start="item in \$data"
              class="table__row--clickable"
              ng-click="\$ctrl.itemClicked(item, \$event)"
              ng-class="{'selected': \$ctrl.selectedCheckId === item.id}">
            <td data-title="'No'">
              {{\$index+1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}
            </td>

            <td data-title="'Loan Product'">{{item.productName }}</td>
            <td data-title="'Loan No.'">{{item.productNumber }}</td>
            <td data-title="'MICR'">{{item.micrNumber }}</td>
            <td data-title="'Status'" ng-class="\$ctrl.getStatusStyle(item.status)">{{item.status | prettyEnum }}</td>
            <td data-title="'Amount'">{{item.amount | nxCurrency }}</td>
            <td data-title="'Type'">{{item.type | prettyEnum }}</td>
            <td data-title="'Due date'">{{item.amortizationDueDate | prettyDate }}</td>
            <td data-title="'Cleared on'">{{(item.clearedOn | prettyDate) || '-' }}</td>
          </tr>
          <tr ng-repeat-end class="table__row--not-hoverable">
            <td colspan="100%">
              <div class="toggleable-panel-wrapper"
                   ng-class="{'toggleable-panel-wrapper--toggled': \$ctrl.selectedCheckId === item.id}">
                <inline-panel on-hide="\$ctrl.hideInlinePanel()">
                  <div class="inline-panel__list">
                    <div class="inline-panel__container" ng-repeat="detail in \$ctrl.selectedCheck.details">
                      <label class="inline-panel__label">{{detail.label}}:</label>
                      <p class="inline-panel__value">{{detail.value}}</p>
                    </div>
                  </div>
                  <div class="inline-panel-footer">
                    <button class="btn btn-info action-button"
                            type="button"
                            ng-click="\$ctrl.goToLoan(item)">
                      Open loan
                    </button>
                    <button class="btn btn-primary action-button"
                            type="button"
                            ng-if="\$ctrl.isPaymentReceiptAvailable(item)"
                            ng-click="\$ctrl.showPaymentReceipt(item)">
                      Print payment invoice
                    </button>
                  </div>
                </inline-panel>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div ng-if="!\$ctrl.isDataPresent()" class="empty-message">
    <span>No checks matching given criteria found</span>
  </div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/check/loan-pdc/loan-pdc-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;